import './App.css';
import BasedStation from './components/BasedStation/BasedStation';

function App() {
  return (
    <BasedStation />
  );
}

export default App;